import { useEffect, useRef } from "react";
import "./BaseModal.css";
interface BaseModalPropsExtended {
	readonly shown: boolean;
	readonly close: (() => void) | null;
	readonly children: React.ReactNode;
	readonly dialogSize: "xs" | "sm" | "md" | "lg" | "xl";
}
export function BaseModal(props: BaseModalPropsExtended) {
	const modalRef = useRef<HTMLDivElement>(null);
	const prevState = useRef(false);

	useEffect(() => {
		if (modalRef.current == null) return;
		if (props.shown == prevState.current) return;
		prevState.current = props.shown;

		if (props.shown) {
			modalRef.current.style.display = "block";
			modalRef.current.classList.add("in");
			modalRef.current.animate(
				{
					opacity: [0, 1],
				},
				{
					duration: 300,
					easing: "ease-in",
					fill: "forwards",
				},
			);
		} else {
			modalRef.current.classList.remove("in");
			const animation = modalRef.current.animate(
				{
					opacity: [1, 0],
				},
				{
					duration: 300,
					easing: "ease-out",
					fill: "forwards",
				},
			);

			animation.onfinish = () => {
				if (modalRef.current == null) return;
				modalRef.current.style.display = "none";
			};
		}
	}, [props.shown]);

	return (
		<div className="myModal" tabIndex={-1} role="dialog" ref={modalRef}>
			<div className="backdrop" onClick={props.close ?? undefined} />
			{/* Please tailwind stop unloading the classes */}
			<div style={{ display: "none" }} className="w-xs w-sm w-md w-lg w-xl" />
			<div className={`dialog w-${props.dialogSize}`} role="document">
				<div
					className="modal-content"
					style={{ maxHeight: "95vh", overflowY: "auto" }}
				>
					{props.children}
				</div>
			</div>
		</div>
	);
}

export function ModalCloseCross(props: { readonly onClick: () => void }) {
	return (
		<button
			type="button"
			className="close"
			aria-label="Close"
			onClick={props.onClick}
		>
			<i className="fa fa-times" />
		</button>
	);
}

export interface BaseModalProps {
	readonly shown: boolean;
	readonly close: () => void;
}
